import { render } from "./AppointmentTable.vue?vue&type=template&id=646fc62a&scoped=true&ts=true"
import script from "./AppointmentTable.ts?vue&type=script&lang=ts"
export * from "./AppointmentTable.ts?vue&type=script&lang=ts"

import "./AppointmentTable.scss?vue&type=style&index=0&id=646fc62a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646fc62a"]])

export default __exports__